import InboxStore from './InboxStore';

export * from './InboxStore';
export default InboxStore;
